import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './ui/Button';
import Icon from './ui/Icon';

const BackButton = ({ 
  to = null, 
  label = "Back", 
  variant = "outline", 
  size = "sm",
  className = "",
  onClick = null
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant={variant}
      size={size}
      className={`flex items-center gap-2 ${className}`}
    >
      <Icon name="ArrowLeft" size={16} />
      {label}
    </Button>
  );
};

export default BackButton;